"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = Error500;
var _icon = require("@react-spectrum/icon");
var _react = _interopRequireDefault(require("react"));
function Error500(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.Illustration, props, /*#__PURE__*/_react.default.createElement("svg", {
    width: "146.569",
    height: "94"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(-392.731 -2966.5)"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M415.8 2988v-18a2.006 2.006 0 012-2h118a2.006 2.006 0 012 2v23a2.006 2.006 0 01-2 2h-110M428.8 3000h107a2.006 2.006 0 012 2v23a2.006 2.006 0 01-2 2h-92M443.8 3032h92a2.006 2.006 0 012 2v23a2.006 2.006 0 01-2 2h-118a2.006 2.006 0 01-2-2v-20M526.8 3028v3M526.8 2996v3",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    transform: "translate(522.8 2977.5)",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    transform: "translate(522.8 3010)",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "4",
    cy: "4",
    r: "4",
    transform: "translate(522.8 3041.5)",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    fill: "none"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M413.1 2995.5l-18.4 31.1a2.916 2.916 0 002.6 4.4h36.9a2.933 2.933 0 002.6-4.4l-18.4-31.1a3.091 3.091 0 00-5.3 0zM415.8 3016.2v-6.9",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10",
    strokeWidth: "3"
  }), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "1.9",
    cy: "1.9",
    r: "1.9",
    transform: "translate(413.9 3020.3)",
    stroke: "none"
  }))));
}